import mutations from './me/mutations';
import actions from './me/actions';
import getters from './me/getters';

const me = {
  namespaced: true,
  state: {
    item: {
      token: null,
      avatar: null,
      first_name: null,
      last_name: null,
      email: null,
      password: null,
    },
    currentPassword: null,
    errors: [],
  },
  getters,
  mutations,
  actions,
};

export default me;
